import { connect } from 'react-redux';
import Component from './Component';


export default connect(null, null)(Component);



// WEBPACK FOOTER //
// ./src/app/components/VideoPlayer/index.js